import { mapState } from "vuex";
export const commentIndexMixins = {
  computed: {
    commentTopBarList() {
      let topbarList = [
          {
              name: "评论管理",
              isActive: false,
              path: "/comment",
              icon:require("@/assets/img/menuIcons/icon-comment.png")
          },
      ];
      topbarList.forEach(val => {
          if (val.path == this.$route.path) {
              val.isActive = true;
          }
          if (val.childrenPath) {
              if (~val.childrenPath.indexOf(this.$route.path)) {
                  val.isActive = true;
              }
          }
      });
      return topbarList;
  }
  },
}
